module.exports = __webpack_public_path__ + "img/dlqh.19c5858e.svg";